import { HsArticleData } from '@hsetu/ngui-views';
import { ItemStockItem } from '../models/item-stock-item.model';
import { ArticleItem } from '../models/article-item.model';

export class ArticleDataMapper {
  public mapToHsArticleData(itemStockItem: ItemStockItem): HsArticleData {
    const title =
      itemStockItem.articleNumber && itemStockItem.articleNumber.trim() !== ''
        ? `[${itemStockItem.articleNumber}] ${itemStockItem.infoDesc}`
        : itemStockItem.infoDesc;
    return {
      id: itemStockItem.uId,
      title: title,
      articleNumber: itemStockItem.articleNumber,
      price: itemStockItem.priceTotal?.netTotal,
      unit: itemStockItem.unit,
      manufacturer: itemStockItem.manufacturerLabel,
    };
  }

  public mapPutItemRequest(data: ArticleItem) {
    const request = {
      UId: data.uId,
      TaskId: data.taskId,
      InfoDesc: data.infoDesc,
      Amount: data.amount ? Number(data.amount) : 0,
      Unit: data.unit,
      ArticleNumber: data.articleNumber,
      ManufacturerLabel: data.manufacturerLabel,
      SortNum: data.sortNum,
      Type: data.type,
      ApplyTo: data.applyTo,
      ItemIds: data.itemIds,
      Percentage: data.percentage,
      PriceTotal: data.priceTotal,
    };

    return request;
  }
}
